/**
 * Formats strings to confirm with Datadog's tag format.
 *
 * {@link https://docs.datadoghq.com/getting_started/tagging/#define-tags}
 */
export const formatVersionForDatadog = (str: string): string => {
    return str.replaceAll(/[^\p{L}\p{N}_\-:./]/gu, '_');
};
